<template>
  <div class="w-full md:w-full" style="z-index: 5000">
    <vs-select autocomplete class="selectExample w-full" v-model="answer">
      <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in options" />
    </vs-select>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String | Boolean,
      required: false
    },
    Item: {
      type: Object,
      required: true,
      default: ""
    },
    change: {
      type: Promise | Function,
      required: true,
      default: () => {}
    }
  },
  data() {
    return {
      options: [
        { value: true, text: "(Boolean) es verdadero" },
        { value: false, text: "(Boolean) es falso" }
      ]
    };
  },
  computed: {
    /**
     * Obtiene ó coloca la respuesta booleana de la pregunta
     */
    answer: {
      get() {
        return this.value === "true" || this.value === true ? true : false;
      },
      set(value) {
        const _value = value === "true" || value === true ? true : false;
        this.$emit("input", _value);
        this.change(_value, this.Item);
      }
    }
  }
};
</script>

<style lang="scss">
.vs-select--options {
  z-index: 2000000;
}
#Compound {
  .input-select {
    background-color: transparent;
    border: none;
  }
}
</style>
